// extracted by mini-css-extract-plugin
export var audioPlayer = "_te-0";